import RedditAds from "../../../../contents/docs/cdp/sources/_snippets/source-reddit-ads.mdx";
import * as React from 'react';
export default {
  RedditAds,
  React
};